import { useCallback } from 'react';

export function useGridNav(gridId = 'grid') {
  // Inputs should have data-row & data-col and live under [data-grid="gridId"]
  const focusCell = useCallback((r: number, c: number) => {
    const selector = `[data-grid="${gridId}"] [data-row="${r}"][data-col="${c}"] input, [data-grid="${gridId}"] [data-row="${r}"][data-col="${c}"] textarea`;
    const el = document.querySelector<HTMLInputElement | HTMLTextAreaElement>(selector);
    el?.focus();
    el?.select?.();
  }, [gridId]);

  const onKeyDown = useCallback((e: React.KeyboardEvent, r: number, c: number, maxR: number, maxC: number) => {
    const { key, shiftKey } = e;

    if (key === 'Tab') {
      e.preventDefault();
      if (shiftKey) {
        const prevC = c > 0 ? c - 1 : maxC;
        const prevR = prevC === maxC ? Math.max(0, r - 1) : r;
        focusCell(prevR, prevC);
      } else {
        const nextC = c < maxC ? c + 1 : 0;
        const nextR = nextC === 0 ? Math.min(maxR, r + 1) : r;
        focusCell(nextR, nextC);
      }
      return;
    }

    if (key === 'Enter') {
      e.preventDefault();
      focusCell(Math.min(maxR, r + 1), c);
      return;
    }

    if (key === 'ArrowRight') { e.preventDefault(); focusCell(r, Math.min(maxC, c + 1)); }
    if (key === 'ArrowLeft')  { e.preventDefault(); focusCell(r, Math.max(0,    c - 1)); }
    if (key === 'ArrowDown')  { e.preventDefault(); focusCell(Math.min(maxR, r + 1), c); }
    if (key === 'ArrowUp')    { e.preventDefault(); focusCell(Math.max(0,    r - 1), c); }
  }, [focusCell]);

  return { onKeyDown, focusCell };
}
